import { TERMINAL } from './apiModules'

import { post } from '@/utils/request'

export function getRcoverImageInfo(id) {
  return post(`${TERMINAL}/getBackUpInfo`, {
    id
  })
}

export function revertBackUp(params) {
  return post(`${TERMINAL}/revertBackUp`, {
    pwd: params.pwd,
    idArr: params.idArr
  })
}

export function batchRevert(params) {
  return post(`${TERMINAL}/batchRevert`, {
    pwd: params.pwd,
    idArr: params.idArr,
    revertBackup: params.revertBackup
  })
}
export function terminalBind({ userName, terminalId }) {
  return post(`${TERMINAL}/binding`, {
    userName, //用户name
    terminalId //终端socket_id
  })
}

export function terminalUnbindBind({ userId, terminalId, smsVerifyCode }) {
  return post(`${TERMINAL}/unbind`, {
    userId, //用户id
    terminalId, //终端socket_id
    smsVerifyCode //验证码
  })
}

export function checkNameUnique({ username }) {
  return post(`${TERMINAL}/user/checkNameUnique`, {
    username
  })
}

export function searchUser({ searchKeyword }) {
  //@linfeng 说用这个接口查找用户
  return post(`${TERMINAL}/user/list`, {
    exactMatchArr: [],
    limit: 50,
    matchArr: [],
    needForceRefresh: false,
    page: 0,
    searchKeyword
  })
}

export function collectTerminalAndDeskLog(params) {
  return post(`${TERMINAL}/collectTerminalAndDeskLog`, {
    id: params.id,
    email: params.email
  })
}

export function switchShareStrategy(params) {
  return post(`${TERMINAL}/switchShareStrategy`, {
    id: params.id,
    switchShareStrategy: params.switchShareStrategy
  })
}

export function getSoftwareList(
  params = {
    page: '',
    limit: '',
    type: '',
    searchKeyword: ''
  }
) {
  return post(`${TERMINAL}/getSoftwarePage`, params)
}

export function getSoftwareDictionary(
  params = {
    page: '',
    limit: '',
    searchKeyword: ''
  }
) {
  return post(`${TERMINAL}/getSoftwareDictPage`, params)
}

export function addGlobalSoftwareDict(
  params = {
    name: '',
    matchType: ''
  }
) {
  return post(`${TERMINAL}/addGlobalSoftwareDict`, params)
}

// 删除软件字典
export function deleteSoftwareDict(
  params = {
    idArr: []
  }
) {
  return post(`${TERMINAL}/deleteSoftwareDict`, params)
}

// 同步软件字典至终端分组
export function synchGlobalSoftwareDict(params = {}) {
  return post(`${TERMINAL}/synchGlobalSoftwareDict`, params)
}
